export function castPerson(p) {
  p["score_color"] = p.score.color
  delete p.score
  return p
}
